import { render, staticRenderFns } from "./AtomView.vue?vue&type=template&id=527c9d90&scoped=true&"
import script from "./AtomView.vue?vue&type=script&lang=ts&"
export * from "./AtomView.vue?vue&type=script&lang=ts&"
import style0 from "./AtomView.vue?vue&type=style&index=0&id=527c9d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c9d90",
  null
  
)

export default component.exports